// Словарь интерфейса: kk
const kk = {
  "home": {
    "title": "Басты бет",
    "description": "Бұл біздің веб-сайтымыздың басты беті.",
    "branches": "Филиалдар",
    "invoices": "Шоттар",
    "warehouse": "Қойма",
    "bonuses": "Бонустар",
    "terms": "Шарттар",
    "contacts": "Байланыс",
    "parcels": "Сәлемдемелер",
    "account": "Аккаунт",
    "calculator": "Калькулятор",
    "dashboard": "Басқару тақтасы",
    "banner": "Баннер"
  },
  "about": {
    "title": "Біз туралы",
    "description": "Компаниямыз туралы толығырақ біліңіз."
  },
  "contact": {
    "title": "Байланыс",
    "description": "Бізбен байланысу үшін осы жерді пайдаланыңыз."
  },
  "menu": {
    "instruction": "Нұсқаулық",
    "branches": "Филиалдар",
    "warehouseAddress": "Қойманың мекенжайы",
    "lostItems": "Жоғалған тауарлар",
    "contacts": "Байланыс",
    "copy": "Көшіру",
    "aboutUs": "Біз туралы",
    "prohibitedItems": "Тапсырыс беруге болмайтын тауарлар",
    "home": "Басты бет",
    "parcels": "Сәлемдемелер",
    "profile": "Профиль",
    "myParcels": "Менің тауарларым",
    "addTrack": "Трек қосу",
    "archive": "Мұрағат",
    "allParcels": "Барлық сәлемдемелер",
    "settings": "Параметрлер",
    "username": "Клиент коды (жеткізу мекенжайындағыдай)",
    "saveUsername": "Сақтау",
    "currentPassword": "Ағымдағы пароль",
    "newPassword": "Жаңа пароль",
    "changePassword": "Құпия сөзді өзгерту",
    "close": "Жабу",
    "dashboard": "Басқару тақтасы",
    "logout": "Шығу",
    "about": "Сипаттама",
    "moreTrack": "Барлық тауарлар",
    "passwd": "Құпия сөз",
    "notifications": "Хабарландыру"
  },
  "common": {
    "loading": "Жүктелуде...",
    "back": "Артқа",
    "cancel": "Бас тарту",
    "save": "Сақтау",
    "delete": "Жою",
    "edit": "Өзгерту",
    "all": "Барлығы",
    "archive": "Мұрағат",
    "next": "Алға",
    "prev": "Артқа",
    "page": "{{page}} / {{total}} бет",
    "none": "—"
  },
  "account": {
    "title": "Аккаунт",
    "name": "Аты-жөні:",
    "phone": "Телефон:",
    "username": "Username:",
    "branch": "Филиал:",
    "notSet": "көрсетілмеген",
    "password": "ҚҰПИЯ СӨЗ",
    "changePassword": "Құпия сөзді өзгерту",
    "logout": "Аккаунттан шығу",
    "loadFail": "Профиль деректерін жүктеу мүмкін болмады.",
    "theme": "ТАҚЫРЫП",
    "themeAuto": "Авто",
    "themeLight": "Жарық",
    "themeDark": "Қараңғы",
    "language": "ТІЛ",
    "accent": "ТҮС ГАММАСЫ",
    "accentGreen": "Классикалық",
    "accentRed": "Қызыл (қосымшадағыдай)",
    "accentBlue": "Көк",
    "accentPurple": "Күлгін",
    "accentOrange": "Қызғылт сары",
    "accentTeal": "Көгілдір",
    "accentPink": "Қызғылт"
  },
  "parcels": {
    "title": "Менің сәлемдемелерім",
    "addTitle": "Сәлемдеме қосу",
    "trackPh": "Трек нөмірін енгізіңіз",
    "descPh": "Сипаттама (мысалы: Zara күртесі)",
    "fillAll": "Барлық өрістерді толтырыңыз",
    "notAuth": "Пайдаланушы авторизацияланбаған",
    "added": "Бетбелгі қосылды",
    "addError": "Сәлемдемені қосу кезінде қате шықты",
    "archiveAll": "Алынғандардың барлығын мұрағатқа жіберу",
    "archiveCount": "{{count}} тректі мұрағатқа жіберу керек пе?",
    "archiveBtn": "Мұрағатқа жіберу",
    "toArchive": "Мұрағатқа",
    "archiveOne": "Мұрағатқа қосу керек пе?",
    "archived": "{{total}} трекдің {{done}} мұрағатқа жіберілді",
    "archivedOne": "Мұрағатқа қосылды",
    "noIssued": "Берілген треклер жоқ",
    "deleteQ": "Бетбелгіні жою керек пе?",
    "deleted": "Бетбелгі жойылды",
    "saved": "Бетбелгі сақталды",
    "noBookmarks": "Бетбелгілер жоқ",
    "noHistory": "Тарих жоқ",
    "showFull": "Толық тарихты көрсету",
    "collapse": "Тарихты жасыру",
    "editTitle": "Бетбелгіні өзгерту",
    "trackNumber": "Трек нөмірі",
    "description": "Сипаттама",
    "errArchive": "Мұрағатқа жіберу кезінде қате шықты",
    "errLoad": "Бетбелгілерді алу кезінде қате шықты",
    "errDelete": "Бетбелгіні жою кезінде қате шықты",
    "errSave": "Бетбелгіні сақтау кезінде қате шықты",
    "archiveAllTitle": "Барлық тректі мұрағатқа жіберу",
    "archiveOneTitle": "Мұрағатқа"
  },
  "auth": {
    "loginTitle": "Жүйеге кіру",
    "loginSubtitle": "Телефон нөміріңіз бен құпия сөзді енгізіңіз",
    "login": "Кіру",
    "noAccount": "Аккаунт жоқ па? Тіркелу",
    "forgot": "Құпия сөзді ұмыттыңыз ба?",
    "offer": "Жария оферта",
    "regTitle": "Тіркелу",
    "name": "Аты",
    "surname": "Тегі (міндетті емес)",
    "usernamePh": "Клиент коды — мекенжайдағыдай",
    "codeHint": "Клиент кодын филиал өкілі жеке хабарламамен береді.",
    "invitedBranch": "Филиал: {{name}}",
    "referrerPh": "Шақырған клиенттің нөмірі (міндетті емес)",
    "inviteNotice": "Тіркелу клиент коды бойынша жүргізіледі: оны филиал өкілі жеке хабарламамен береді. Кодты және сізге жіберілген телефон нөмірін енгізіңіз.",
    "chooseBranch": "Филиалды таңдаңыз",
    "passwordPh": "Құпия сөз ойлап табыңыз",
    "agree": "Жеке деректерді өңдеуге және мына шарттармен келісемін:",
    "terms": "шарттар",
    "register": "Тіркелу"
  },
  "status": {
    "expected": "Күтілуде",
    "arrivedWarehouse": "Қоймаға келді",
    "sent": "Жөнелтілді",
    "arrivedBranch": "Филиалға келді",
    "arrivedAlmaty": "Алматыға келді",
    "issued": "Берілді",
    "ready": "Беруге дайын",
    "inTransit": "Жолда",
    "unknown": "Белгісіз"
  }
};

export default kk;
